import { OCR_ENDPOINTS, OCR_LIMITS } from '../core/config.js';
import { apiRequest } from './api-client.js';
import { assertJob, normalizeDocument } from '../contracts/ocr-document.js';

export async function createOcrJob({ files = [], url = '', sourceLanguage = 'auto', targetLanguage, mode = 'smart' }, signal) {
  let body;
  let headers;
  if (url) {
    headers = { 'Content-Type': 'application/json' };
    body = JSON.stringify({
      source: { kind: 'url', value: url },
      sourceLanguage,
      targetLanguage,
      mode
    });
  } else {
    body = new FormData();
    files.forEach(file => body.append('files', file, file.name));
    body.append('sourceLanguage', sourceLanguage);
    body.append('targetLanguage', targetLanguage);
    body.append('mode', mode);
  }
  return assertJob(await apiRequest(OCR_ENDPOINTS.jobs, { method: 'POST', headers, body, signal }));
}

export async function getOcrJob(jobId, signal) {
  return assertJob(await apiRequest(`${OCR_ENDPOINTS.jobs}/${encodeURIComponent(jobId)}`, { signal }));
}

export async function cancelOcrJob(jobId) {
  return apiRequest(`${OCR_ENDPOINTS.jobs}/${encodeURIComponent(jobId)}`, { method: 'DELETE' });
}

export async function waitForOcrJob(jobId, { signal, onUpdate } = {}) {
  while (!signal?.aborted) {
    const job = await getOcrJob(jobId, signal);
    onUpdate?.(job);
    if (job.status === 'ready') return normalizeDocument(job.document);
    if (job.status === 'failed' || job.status === 'cancelled') throw new Error(job.error || `Tâche ${job.status}.`);
    await new Promise((resolve, reject) => {
      const timeout = setTimeout(resolve, OCR_LIMITS.pollIntervalMs);
      signal?.addEventListener('abort', () => {
        clearTimeout(timeout);
        reject(new DOMException('Aborted', 'AbortError'));
      }, { once: true });
    });
  }
  throw new DOMException('Aborted', 'AbortError');
}

export async function translateOcrDocument(document, { sourceLanguage, targetLanguage, mode }, signal) {
  const payload = await apiRequest(OCR_ENDPOINTS.translate, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ document, sourceLanguage, targetLanguage, mode }),
    signal
  });
  return normalizeDocument(payload.document);
}
